export const HANDICARE_USER_STORAGE_KEY = 'HANDICARE_USER'
